import React from 'react';
import PropTypes from 'prop-types';

function IconPlayLeft({ color = '#121212', size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.9476 13.8817L3.748 8.22682C3.56787 8.10263 3.56787 7.83651 3.748 7.71232L11.9476 2.05751C12.1549 1.91444 12.4376 2.06288 12.4376 2.31476L12.4376 13.6244C12.4376 13.8763 12.1549 14.0247 11.9476 13.8817Z" fill={color}/>
    </svg>
  )
}

IconPlayLeft.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconPlayLeft;
